import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonOpenForOrdersField from '../../../common/fields/OpenForOrdersField';
import { OriginalDeviationFieldName } from '../../types';

const OpenForOrdersField: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <CommonOpenForOrdersField
      fieldName={OriginalDeviationFieldName.OPEN_FOR_ORDERS}
      label={t('originalDeviationPopup.form.openForOrders.label')}
      subLabel={t('originalDeviationPopup.form.openForOrders.subLabel')}
    />
  );
};
OpenForOrdersField.displayName = 'OpenForOrdersField';

export default OpenForOrdersField;
